import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createAccount as universalCreateAccount, earnPoints as universalEarnPoints, adjustPoints as universalAdjustPoints, redeemPoints as universalRedeemPoints, redeemDeterminedAmountOfPoints as universalRedeemDeterminedAmountOfPoints, refundTransaction as universalRefundTransaction, getAccount as universalGetAccount, listUserAccounts as universalListUserAccounts, getProgramTotals as universalGetProgramTotals, getCurrentMemberAccount as universalGetCurrentMemberAccount, getAccountBySecondaryId as universalGetAccountBySecondaryId, listAccounts as universalListAccounts, searchAccounts as universalSearchAccounts, exportAccounts as universalExportAccounts, countAccounts as universalCountAccounts, bulkAdjustPoints as universalBulkAdjustPoints, bulkUpsertAccounts as universalBulkUpsertAccounts, setMissingMemberId as universalSetMissingMemberId, } from './loyalty-v1-account.universal';
import { UpdateTrigger, SortOrder, SortType, SortDirection, MissingValues, ScalarType, NestedAggregationType, DateHistogramAggregationInterval, AggregationType, Mode, Status, ProviderName, IntervalUnit, SubscriptionStatus, ReactivationReasonEnum, Initiator, UnassignReason, ContractSwitchType, ContractSwitchReason, PriceIncreaseTrigger, ProductAdjustment, WebhookIdentityType, } from './loyalty-v1-account.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.loyalty.v1.account', module_name: 'wix-loyalty.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createAccount: (contactId) => {
            const methodLogData = {
                method_name: 'createAccount',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.createAccount',
            };
            return universalCreateAccount(contactId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        earnPoints: (accountId, options) => {
            const methodLogData = {
                method_name: 'earnPoints',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.earnPoints',
            };
            return universalEarnPoints(accountId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        adjustPoints: (accountId, options) => {
            const methodLogData = {
                method_name: 'adjustPoints',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.adjustPoints',
            };
            return universalAdjustPoints(accountId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        redeemPoints: (accountId, rewardId, options) => {
            const methodLogData = {
                method_name: 'redeemPoints',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.redeemPoints',
            };
            return universalRedeemPoints(accountId, rewardId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        redeemDeterminedAmountOfPoints: (accountId, rewardId, options) => {
            const methodLogData = {
                method_name: 'redeemDeterminedAmountOfPoints',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.redeemDeterminedAmountOfPoints',
            };
            return universalRedeemDeterminedAmountOfPoints(accountId, rewardId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        refundTransaction: (transactionId) => {
            const methodLogData = {
                method_name: 'refundTransaction',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.refundTransaction',
            };
            return universalRefundTransaction(transactionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getAccount: (_id) => {
            const methodLogData = {
                method_name: 'getAccount',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.getAccount',
            };
            return universalGetAccount(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listUserAccounts: (options) => {
            const methodLogData = {
                method_name: 'listUserAccounts',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.listUserAccounts',
            };
            return universalListUserAccounts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getProgramTotals: () => {
            const methodLogData = {
                method_name: 'getProgramTotals',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.getProgramTotals',
            };
            return universalGetProgramTotals(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCurrentMemberAccount: () => {
            const methodLogData = {
                method_name: 'getCurrentMemberAccount',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.getCurrentMemberAccount',
            };
            return universalGetCurrentMemberAccount(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getAccountBySecondaryId: (options) => {
            const methodLogData = {
                method_name: 'getAccountBySecondaryId',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.getAccountBySecondaryId',
            };
            return universalGetAccountBySecondaryId(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listAccounts: (options) => {
            const methodLogData = {
                method_name: 'listAccounts',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.listAccounts',
            };
            return universalListAccounts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchAccounts: (options) => {
            const methodLogData = {
                method_name: 'searchAccounts',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.searchAccounts',
            };
            return universalSearchAccounts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        exportAccounts: (options) => {
            const methodLogData = {
                method_name: 'exportAccounts',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.exportAccounts',
            };
            return universalExportAccounts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countAccounts: (options) => {
            const methodLogData = {
                method_name: 'countAccounts',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.countAccounts',
            };
            return universalCountAccounts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAdjustPoints: (options) => {
            const methodLogData = {
                method_name: 'bulkAdjustPoints',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.bulkAdjustPoints',
            };
            return universalBulkAdjustPoints(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpsertAccounts: (accounts, options) => {
            const methodLogData = {
                method_name: 'bulkUpsertAccounts',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.bulkUpsertAccounts',
            };
            return universalBulkUpsertAccounts(accounts, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setMissingMemberId: (accountId) => {
            const methodLogData = {
                method_name: 'setMissingMemberId',
                service_name: 'com.wixpress.loyalty.account.LoyaltyAccounts',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-loyalty.v2,entity=wix.loyalty.v1.account,environment=velo-frontend,method-fqn=com.wixpress.loyalty.account.LoyaltyAccounts.setMissingMemberId',
            };
            return universalSetMissingMemberId(accountId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        UpdateTrigger,
        SortOrder,
        SortType,
        SortDirection,
        MissingValues,
        ScalarType,
        NestedAggregationType,
        DateHistogramAggregationInterval,
        AggregationType,
        Mode,
        Status,
        ProviderName,
        IntervalUnit,
        SubscriptionStatus,
        ReactivationReasonEnum,
        Initiator,
        UnassignReason,
        ContractSwitchType,
        ContractSwitchReason,
        PriceIncreaseTrigger,
        ProductAdjustment,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=loyalty-v1-account.frontend.js.map